export const ID = 'ID';
export const TITLE = 'TITLE';
export const COUNTRY = 'COUNTRY';
export const ADDRESS = 'ADDRESS';
export const SERIAL = 'SERIAL';
export const SUB_START_DATE = 'SUB_START_DATE';
export const SUB_PERIOD = 'SUB_PERIOD';
export const STUDENT_LICENCES = 'STUDENT_LICENCES';
export const TEACHER_LICENCES = 'TEACHER_LICENCES';
export const CREATED_AT = 'CREATED_AT';
export const COURSES = 'COURSES';
export const SCHOOL_FILL_INFO = 'SCHOOL_FILL_INFO';
export const SCHOOL_CLEAR_INFO = 'SCHOOL_CLEAR_INFO';
export const SCHOOL_FILL_COURSES = 'SCHOOL_FILL_COURSES';
export const LIST = 'LIST';
export const DEFAULT_LANGUAGE = 'DEFAULT_LANGUAGE';



// WEBPACK FOOTER //
// ./src/store/modules/school/mutation-types.js